__webpack_require__.p = "/SnowPrediction/";